import SidebarContent from "./SidebarContent";

export default function LargeSidebar() {
  return (
    <div className="border border-1 rounded px-2" style={{ minWidth: 250 }}>
      <SidebarContent />
    </div>
  );
}
